import React, { useState } from 'react';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//store
import useComnStore from 'src/webapp/stores/comn.store';

const useComnHook = () => {
    const { axiosPostHandler } = useAxiosHook();

    /* ==================== 토큰만료기한 설정(refhresh, access) ==================== */
    //refreshToken
    const refreshTokenExpires = () => {
        const now = new Date();
        const expires = new Date(now.setHours(now.getHours() + 12));//const expires = new Date(now.setDate(now.getDate() + 1));
        return expires;
    }
    //accessToken
    const accessTokenExpires = () => {
        const now = new Date();
        const expires = new Date(now.setHours(now.getHours() + 1));
        return expires;
    }
    /* ==================== 토큰만료기한 설정(refhresh, access) ==================== */
    /* ==================== 입력validate ==================== */
    //숫자만입력
    const onNumberHandler = (e) => {
        let value = e.target.value;
        const nval = value.replace(/[^0-9]/g, "");
        e.target.value = nval.toString();
    }
    //숫자만입력(세자리콤마)
    const onNumberCommaHandler = (e) => {
        let value = e.target.value ?? e;
        let nval = Number(value.replaceAll(',', ''));
        if(!isNaN(nval)) { nval = nval.toLocaleString('ko-KR'); } 
        else { nval = ''; }
        //if(isNaN(nval)) { nval = 0;} 
        //else { nval = nval.toLocaleString('ko-KR'); }
        e.target.value = nval;
    };
    //숫자만입력(세자리콤마)
    const onNumberCommaFormat = (value) => {
        //let value = e.target.value;
        let nval = new Number(value?.indexOf(',') != -1 ? value : value.eplaceAll(",", ""));
        if(!isNaN(nval)) { nval = nval.toLocaleString('ko-KR'); } 
        else { nval = ''; }
        //if(isNaN(nval)) { nval = 0;} 
        //else { nval = nval.toLocaleString('ko-KR'); }
        return nval;
    };
    //숫자(세자리콤마)
    const setNumberHandler = (value) => {
        const nval = value.toString().replaceAll(',', '').replace(/[^0-9]/g, "");
        const num = nval.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return num;
    }
    //세자리콤마(소수점)핸들러
	const onDecimalCommaHandler = (e) => {
		//숫자, .만 입력받는식
		let inputValue = e.target.value.replace(/[^0-9.]/g, "");
		const decimal = inputValue.split("."); // 마침표(.) 단위로 배열 쪼개기
		// 소수점 이전에만 1000단위 마다 comma 추가를 적용
		let formattedNumber = decimal[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		// 소수점을 찍지 않았을 때 두번째 배열 요소는 undefined인데, 
		// 만약 두번째 요소가 undefined가 아닌 경우
		if (decimal[1] !== undefined) {
			// 배열의 첫번째 정수는 정수 자신에서 마침표와 소수 이후의 값들을 모두 결합
			formattedNumber = formattedNumber + "." + decimal[1];
		}
		e.target.value = formattedNumber;
	}
    //콤마제거 및 타입변환
    const removeCommaHandler = (str) => {
        if (str == '' || str < 0) { return parseInt(0); }

        return parseFloat(str.toString().replace(/,/g, ''));
    }
    /* ==================== 입력validate ==================== */

    //상태필터
    const stateFilter = (type) => {//예약상태- 1.예약진행중, 2.예약완료, 3.입고완료, 4.점검완료, 5.이력등록완료, 6.수락지연취소, 7.미입고취소, 8.취소완료
        switch(type) {
            case "1" : return "예약진행중";
            case "2" : return "예약완료";
            case "3" : return "입고완료";
            case "4" : return "점검완료";
            case "5" : return "이력등록완료";
            case "6" : return "수락지연취소";
            case "7" : return "미입고취소";
            case "8" : return "취소완료";
            default : return "";
        }
    }
    //카테고리필터
    const categoryFilter = (element) => {//카테고리-1.엔진오일, 2.타이어, 3.정기점검, 4.기타
        switch(element) {
            case "1" : return "엔진오일";
            case "2" : return "타이어";
            case "3" : return "정기점검";
            case "4" : return "기타";
        }
    }

    /* ==================== 메세지팝업처리 ==================== */
    const { setMessage } = useComnStore();
    const setOnMessageHandler = (type, label) => {
        let icon = 0;
        switch(type) {
            case 1 : icon = 'submit'; break;
            case 2 : icon = 'error'; break;
            case 3 : icon = 'notice'; break;
        }
        setMessage({type:icon, label:label});
        setTimeout(() => { setMessage({type:null, label:null}); }, 1500);
    }
    /* ==================== 메세지팝업처리 ==================== */

    /* ==================== 공통코드호출 ==================== */
    const [ comnList, setComnList ] = useState([]);
    const comnListAPI = async (str) => {
        const DATA = { "COMN_CD":str };
        const result = await axiosPostHandler(`comnCdListForJson.do`, DATA);
        if(!result || result.message !== "SUCCESS") { setComnList([]); }
        if(result.message === "SUCCESS") { 
            setComnList(result.data); 
        }
    }
    /* ==================== 공통코드호출 ==================== */
    /* =============== 디바운스 =============== */
    const debounce = (callback, delay) => {//callback할 함수 또는 api, delay시간(ms)
        let timer;
        return (...args) => {
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                callback(...args);
            }, delay);
        };
    };
    /* =============== 디바운스 =============== */

    return { refreshTokenExpires, accessTokenExpires,
        setOnMessageHandler,
        onNumberHandler, onNumberCommaHandler, onNumberCommaFormat, removeCommaHandler, onDecimalCommaHandler, setNumberHandler, 
        stateFilter, categoryFilter,
        comnListAPI, comnList,//공통코드호출
        debounce,//디바운스
    };
}

export default useComnHook;